import React from "react";
import AllNotification from "../components/UI/reusable-components/NotificationComponents/AllNotification";

export const NotificationPage=()=>{

    return(
        <div>
            <AllNotification />
        </div>
    )
}